var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4 33.6319V28.2319C72.4 25.7319 70.4 23.7319 67.9 23.7319H16.2C13.7 23.7319 11.7 25.7319 11.7 28.2319V35.4319V70.2319V79.9319C11.7 82.4319 13.7 84.4319 16.2 84.4319H67.9C70.4 84.4319 72.4 82.4319 72.4 79.9319V34.0319",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3 67.3003H61.9001C62.7001 67.3003 63.4001 68.0003 63.4001 68.8003C63.4001 69.6003 62.7001 70.3003 61.9001 70.3003H47.3C46.5 70.3003 45.8 69.6003 45.8 68.8003C45.8 68.0003 46.4 67.3003 47.3 67.3003Z",
    fill: "#F7FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 72.1001H61.9C62.7 72.1001 63.4 72.8001 63.4 73.6001C63.4 74.4001 62.7 75.1001 61.9 75.1001H54C53.2 75.1001 52.5 74.4001 52.5 73.6001C52.5 72.8001 53.1 72.1001 54 72.1001Z",
    fill: "#F7FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2 72.1001C50 72.1001 50.7 72.8001 50.7 73.6001C50.7 74.4001 50 75.1001 49.2 75.1001C48.4 75.1001 47.7 74.4001 47.7 73.6001C47.7 72.8001 48.3 72.1001 49.2 72.1001Z",
    fill: "#F7FAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1999 39.9H39.3999C39.9999 39.9 40.4999 39.3999 40.4999 38.7999V33.9999C40.4999 33.3999 39.9999 32.8999 39.3999 32.8999H20.1999C19.5999 32.7999 19.0999 33.2999 19.0999 33.9999V38.7999C19.0999 39.3999 19.5999 39.9 20.1999 39.9Z",
    fill: "#F7FAFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2999 63.9003H72.7999C75.8999 63.9003 78.3999 61.4003 78.4999 58.3003C78.5999 55.1003 75.8999 52.5003 72.6999 52.5003H56.1999V55.5003C56.1999 56.1003 55.7999 56.7003 55.2999 56.9003C54.6999 57.1003 54.0999 57.0003 53.6999 56.6003L43.8999 47.2003C43.5999 46.9003 43.3999 46.4003 43.3999 45.9003C43.3999 45.4003 43.5999 45.0003 43.8999 44.6003L53.6999 35.2003C54.0999 34.8003 54.7999 34.7003 55.2999 34.9003C55.8999 35.1003 56.1999 35.7003 56.1999 36.3003V39.3003H65.9999H69.9999H72.2999H72.5999C82.9999 39.3003 91.5999 47.7003 91.5999 58.0003C91.6999 68.4003 83.1999 76.9003 72.7999 76.9003H72.2999V63.9003Z",
    fill: "#ECC94B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "1f9cd57520e852da07aed9d94c621262.svg";
export { ForwardRef as ReactComponent };